// extracted by mini-css-extract-plugin
module.exports = {"freebooks":"FreebooksBlock_freebooks__qEma0","freebooks__btnWrap":"FreebooksBlock_freebooks__btnWrap__sj_A_","freebooks__btn":"FreebooksBlock_freebooks__btn__r9Rsu"};